// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useCallback, useEffect, useRef } from 'react'
import './providerNote.scss'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { CharacterLimitCounter, TextEditor } from 'ui_kit_qmd'
import { useProductOrderContext } from '../../../../../../context'
import { MAX_DTS_NOTE_LENGTH } from 'utils/constants'

interface Props {
  noteError: string
}
export const ProviderNote = ({ noteError }: Props) => {
  const { setNote, note } = useProductOrderContext()
  const textEditorRef = useRef(null)
  const orderNote = useRef<string>(note || '')

  useEffect(() => {
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    if (note && textEditorRef.current) textEditorRef.current.onSetValue(note)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const setNoteText = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      setNote(value.replace(/(\r\n|\n|\r)/gm, ' '))
      orderNote.current = value
    },
    [setNote],
  )
  return (
    <div className='provider-order-note-container'>
      <TextEditor
        placeHolderText='Type something'
        id='provider-order-note'
        isError={noteError}
        ref={textEditorRef}
        setText={setNoteText}
        descriptionLocalError={noteError}
      />
      <CharacterLimitCounter
        currentAmount={orderNote.current.length}
        limit={MAX_DTS_NOTE_LENGTH}
        isHighlightError={orderNote.current.length > MAX_DTS_NOTE_LENGTH}
      />
    </div>
  )
}
